import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { ArrowRightIcon } from '../shared/icons/icons';
import './Navbar.css';
import { useNavigate } from 'react-router-dom';

interface INavbarVersionItemProps {
    versionNumber: string;
    linkPrefix: string | undefined;
}

const NavbarVersionItem = ({
    versionNumber,
    linkPrefix,
}: INavbarVersionItemProps) => {
    const localization = useSelector(
        (state: RootState) =>
            state.localization.localizationStrings.susy.navbar.navbarVersionItem
    );
    const navigate = useNavigate();

    const versionClickHandle = () => {
        navigate(`${linkPrefix ? '/' + linkPrefix : ''}/changelog`);
    };

    return (
        <>
            <div className='d-flex align-items-center justify-content-center mb-2'>
                <li
                    className='susy-nav-label-data-protection-version'
                    onClick={() => versionClickHandle()}
                >
                    <div className='d-flex align-items-center'>
                        <span className='susy-nav-label-data-protection-version ml-2'>
                            {localization.version}
                        </span>
                        <span className='susy-nav-label-data-protection-version ml-2 mr-2'>
                            {versionNumber}
                        </span>
                        <ArrowRightIcon />
                    </div>
                </li>
            </div>
        </>
    );
};

export default NavbarVersionItem;
